<template>
  <div class="rightconover">
    <div class="contentwidth">
      <div class="ContentMargin">
        <div class="content_head">
          <div class="content_head_ico">
            <img src="@/assets/images/worktable/titleguoducolor.png" alt=""/>
          </div>
          <div class="content_head_title">当前货位卡</div>
          <div class="content_head_button">
            <div class="content_head_seek content_searchlistbox">
              <lk-button img="searchlist.png" @click="searchlistshow=!searchlistshow"></lk-button>
              <img v-show="searchlistshow" class="content_searchlist" src="@/assets/images/xiala.png" alt="">
            </div>
            <div class="content_head_seek" v-if="permissionAddIs">
              <lk-button img="add.png" @click="findBarn()">生成货位卡</lk-button>
            </div>
            <div class="content_head_seek">
              <lk-button img="export.png" type="lk_button_blue" @click="exportExcel">导出</lk-button>
            </div>
          </div>
        </div>
        <div class="searchlistbox" v-show="searchlistshow">
          <div class="content_head_seek">
            <el-cascader
                v-model="warehouseNumber"
                :options="warehouseNumberList"
                placeholder="仓房"
                clearable
                filterable
            ></el-cascader>
          </div>
          <div class="content_head_seek">
            <el-select v-model="grainNature" filterable placeholder="粮食性质">
              <el-option
                  v-for="item in grainNatureList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="content_head_seek">
            <el-select v-model="grainBelong" filterable placeholder="粮权所属">
              <el-option
                  v-for="item in grainBelongList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="content_head_seek">
            <el-cascader
                v-model="grainKind"
                :options="grainKindList"
                placeholder="粮食品种"
                clearable
                filterable
            ></el-cascader>
          </div>
          <div class="content_head_seek">
            <div class="block">
              <el-date-picker
                  v-model="timepicker"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="content_head_seek">
            <lk-button @click="getDataList(1)">查询</lk-button>
          </div>
          <div class="content_head_seek">
            <lk-button type="lk_button_blue" @click="searchReset">重置</lk-button>
          </div>
        </div>
        <div class="Notice_list">
          <el-table :data="Notice" style="width: 100%">
            <el-table-column prop="barnVName" label="仓房" width="180" align="center"></el-table-column>
            <el-table-column prop="grainNature" label="粮食性质" align="center"></el-table-column>
            <el-table-column prop="grainBelong" label="粮权所属" align="center"></el-table-column>
            <el-table-column prop="foVariety" label="粮食品种" align="center"></el-table-column>
            <el-table-column prop="foOrigin" label="粮食产地" align="center"></el-table-column>
            <el-table-column prop="capacityTotal" label="总仓容(吨)" align="center"></el-table-column>
            <el-table-column prop="capacityCurrent" label="库存总量(吨)" align="center"></el-table-column>
            <el-table-column prop="result" label="检验结论" align="center"></el-table-column>
            <el-table-column prop="createDate" label="生成时间" align="center"></el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button v-if="permissionFindIs" type="text" size="small" @click="buttonSwitch(scope.row.id,1)">详情</el-button>
                <!--                <el-button type="text" size="small" @click="buttonAdd(scope.row.id,2)">编辑</el-button>-->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paging">
          <div class="block">
            <el-pagination
                background
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                :current-page="currentPage"
                :page-size="pageSize"
                :page-sizes="config.pagesizes"
                layout="total, prev, pager, next, jumper,sizes"
                :total="totalPage"
            >
            </el-pagination>
          </div>
        </div>
        <el-dialog
            title="选择需要生成货位卡的仓房"
            :visible.sync="dialogVisible"
            width="30%">
          <div style="margin: 15px 0;"></div>
          <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="barn in barnOptions" :label="barn" :key="barn.key" border>{{ barn.label }}
            </el-checkbox>
          </el-checkbox-group>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="finishCard">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import {httpToken} from "@/utils/http";
import {mapMutations} from "vuex";
import qs from "qs";
import {export2Excel, getdatadirid} from "@/utils/util";
import {getBarnInfoAllSons, getGrainKindDictionary} from "@/utils/warehouseInOut";
import {getjudgePermission} from '@/utils/server/permission'
export default {
  name: "New",
  data() {
    return {
      permissionAddIs:false,//新增权限
      permissionFindIs:false,//详情权限
      Notice: [],
      currentPage: 1,
      pageSize:10,
      totalPage: 0,
      warehouseNumber: [],
      grainNature: "",
      grainBelong: "",
      grainKind: [],
      timepicker: "",
      warehouseNumberList: [],
      grainNatureList: [],
      grainBelongList: [],
      grainKindList: getGrainKindDictionary(),
      checkedCities: [],
      barnOptions: [],
      dialogVisible: false,
      columns: [
        {title: "仓房号", key: "warehouseNumber"},
        {title: "粮食性质", key: "grainNature"},
        {title: "粮权所属", key: "grainBelong"},
        {title: "粮食品种", key: "foVariety"},
        {title: "粮食产地", key: "foOrigin"},
        {title: "总仓容(吨)", key: "capacityTotal"},
        {title: "库存总量(吨)", key: "capacityCurrent"},
        {title: "检验结论", key: "result"},
        {title: "生成时间", key: "createDate"},
      ],
      searchlistshow: false,
      exportData:[],//所有导出数据
    };
  },
  mounted() {
    getjudgePermission('1118').then(res=>{
      this.permissionAddIs=res
    })
    getjudgePermission('1121').then(res=>{
      this.permissionFindIs=res
    })
    this.getGrainBelongOptions()
    this.getBarnInfoOptions()
    this.grainNatureList = getdatadirid('grain_nature')
    this.getDataList(1)
  },
  methods: {
    ...mapMutations('Quality', ['setQualityState', 'setQualityId', 'setQualityBack','setFreightspace']),
    getDataList(page) {
      this.currentPage = page
      let paramData = [{column: 'unit', type: 'eq', value: JSON.parse(sessionStorage.getItem('user')).unitId}]
      if (this.warehouseNumber.length!==0) {
        paramData.push({column: 'barn_v_id', type: 'eq', value: this.warehouseNumber[1]})
      }
      if (this.grainNature) {
        paramData.push({column: 'grain_nature', type: 'eq', value: this.grainNature})
      }
      if (this.grainBelong) {
        paramData.push({column: 'grain_belong', type: 'eq', value: this.grainBelong})
      }
      if (this.grainKind.length!==0) {
        paramData.push({column: 'fo_variety', type: 'eq', value: this.grainKind[1]})
      }
      if (this.timepicker) {
        paramData.push({column: "create_date", type: "ge", value: this.timepicker[0]});
        paramData.push({column: "create_date", type: "le", value: this.timepicker[1] + " 23:59:59"});
      }
      httpToken({
        method: 'post',
        url: '/granary-quality-card/nowCard',
        data: qs.stringify({
          page: page,
          paramData: JSON.stringify(paramData),
          rows: this.pageSize,
        })
      }).then(res => {
        // console.log(res)
        this.Notice = []
        let Data = res.data.data
        if (status === 'delete' && Data.pages < this.currentPage && Data.pages !== 0) {
          this.currentPage = Data.pages
          this.getDataList(this.currentPage)
          return
        }
        let DataList = Data.list
        DataList.forEach((item) => {
          item.capacityCurrent = Math.round(Number(item.capacityCurrent) / 10) / 100
          item.capacityTotal = Math.round(Number(item.capacityTotal) / 10) / 100
          item.createDate = item.createDate.replace('T', ' ')
        })
        this.Notice = Data.list
        this.totalPage = Data.total
      })
    },
    // 查询满仓的仓房
    findBarn() {
      this.checkedCities = []
      httpToken({
        url: '/granary-quality-card/findBarn',
        method: 'post',
      }).then(res => {
        let barnList = res.data.data
        if (barnList === null) {
          this.$message({
            type: 'info',
            message: res.data.msg
          })
        } else {
          this.barnOptions = []
          barnList.forEach((item) => {
            this.barnOptions.push({key: item.id, label: item.name,useDate:item.useDate})
          })
          this.dialogVisible = true
        }
        console.log(res)
      })
    },
    // 生成货位卡
    finishCard() {
      if (this.checkedCities.length !== 0) {
        let count=0
        let nowkey=''
        for(let i=0;i<this.checkedCities.length;i++){
          // 无成货位时间 打开提醒弹窗跳转货位页面
          if(this.checkedCities[i]&&!this.checkedCities[i].useDate){
            count++
            nowkey=this.checkedCities[i]
          }
        }
        if(count==0){
          let barnIds = this.checkedCities.map(item=>{return item.key});
          httpToken({
            url: '/granary-quality-card/finishCard',
            method: 'post',
            data: qs.stringify({
              barnIds: JSON.stringify(barnIds)
            })
          }).then(res => {
            console.log(res)
            this.getDataList(1)
            this.dialogVisible = false
          })
        }else if(count==1){//1条跳转详情
          this.$message({
            message: nowkey.label+'货位未设置启用时间，跳转货位详情页',
            type: 'info'
          })
          this.setFreightspace(nowkey.key)
          this.$emit("update:comName", "BasicsGranary");
        }else{// 多条跳转列表页
          this.$message({
            message: '多个货位未设置启用时间，跳转货位列表页',
            type: 'info'
          })
          this.setFreightspace('')
          this.$emit("update:comName", "BasicsGranary");
        }
      }
    },
    // 搜索重置
    searchReset() {
      this.warehouseNumber = []
      this.grainNature = ''
      this.grainBelong = ''
      this.grainKind = []
      this.timepicker = ''
    },
    // 单选触发
    handleCheckedCitiesChange(value) {
      console.log(value)
    },
    // 详情按键
    buttonSwitch(id, state) {
      this.setQualityId(id);
      this.setQualityState(state);
      this.setQualityBack(this.$store.state.leftNav)
      this.$emit('update:comName', 'BarncardDetail')
    },
    // 新增和编辑按键
    buttonAdd(id, state) {
      this.setQualityId(id);
      this.setQualityState(state);
      this.$emit('update:comName', 'BarncardAdd')
    },
    getexportDataAll() {
      let json = [
        { column: "unit", type: 'eq',value:this.resunit },
        { column: "create_date", type: 'orderByDesc' }
      ];
      // httpToken({
      //   method: 'post',
      //   url: '/granary-quality-card/nowCard',
      //   data: qs.stringify({
      //     page: page,
      //     paramData: JSON.stringify(paramData),
      //     rows: this.pageSize,
      //   })
      // })
      httpToken({
        method: "post",
        url: '/granary-equipment-purchase/all',
        data: qs.stringify({
          paramData:JSON.stringify(json),
        }),
      }).then((res) => {
        this.exportData=res.data.data
      })
    },
    // 导出
    exportExcel() {
      if(this.exportData&&this.exportData.length>0){
        export2Excel(this.columns, this.exportData, "当前仓房货位卡");
      }else{
        this.$message({
          message: '导出数据暂无',
          type: 'info'
        })
      }
    },
    // 分页器
    handleCurrentChange(val) {
      this.getDataList(val)
    },
    handleSizeChange(val){
      this.pageSize=val
      this.getDataList(this.currentPage);
    },
    // 获取粮权所属的下拉选项
    getGrainBelongOptions() {
      httpToken({
        url: '/grain-owned/all',
        method: 'post'
      }).then(res => {
        // console.log(res.data.data)
        const belongList = res.data.data
        this.grainBelongList = []
        for (let j = 0; j < belongList.length; j++) {
          this.grainBelongList.push(
              {
                value: belongList[j].companyName,
                label: belongList[j].companyName
              })
        }
      })
    },
    // 获取仓房的下拉选项
    getBarnInfoOptions() {
      this.warehouseNumberList=getBarnInfoAllSons()
    }
  },
};
</script>
<style scoped lang="scss">
.rightconover {
  height: 100%;
  background-color: #f5f6fa;
  overflow: auto;

  .contentwidth {
    width: 100%;

    .ContentMargin {
      box-sizing: border-box;
      margin: 30px 35px;
      background-color: #ffffff;
      box-shadow: 0 3px 5px 0 #d5dade;
      padding: 30px 40px;
    }
  }
}

::v-deep .el-dialog__body {
  padding: 0 20px;
}

.showbodymax {
  width: 100%;
  font-size: 14px;
  font-family: Source Han Sans CN, serif, serif;
  font-weight: 400;
  color: #969696;

  .title {
    margin-bottom: 24px;
  }
}

.noticebox {
  width: 622px;
  margin: 32px auto;
  padding: 30px 40px;
  background: #ffffff;
  box-sizing: border-box;
  box-shadow: 0 3px 7px 0 rgba(91, 117, 148, 0.26);

  .noticebox_fotbox {
    width: 100%;
    margin-top: 30px;
    display: flex;
    font-size: 14px;
    font-family: PingFang SC, serif;
    font-weight: 500;
    color: #383838;

    .fottitle_left {
    }

    .fottitle_right {
      margin-left: auto;
    }
  }

  .noticebox_table {
    width: 100%;
    min-height: 25px;
    text-align: left;
    border-color: #DCDCDC;
    border-collapse: collapse;
    font-size: 14px;

    tr {
      td {
        padding: 15px;
        box-sizing: border-box;
        vertical-align: top;
      }

      td:nth-child(odd) {
        width: 90px;
        height: 40px;
      }

      td:nth-child(even) {
        width: 180px;
        height: 40px;
      }
    }

    .bigtr {
      .bigtd {
        width: 100%;
        height: 200px;

        .Notice_alert {
          -webkit-text-size-adjust: none;
          font-size: 9px;
          color: #969696;

          ::v-deep .el-table {
            -webkit-text-size-adjust: none;
            font-size: 9px;
          }

          ::v-deep .el-table th {
            background-color: #f4f7fd;
            color: #969696;
          }

          ::v-deep .el-table .el-table__cell {
            padding: 6px 0;
          }

          ::v-deep .el-table thead {
            color: #969696;
            -webkit-text-size-adjust: none;
            font-size: 9px;
          }
        }
      }
    }
  }

  .noticebox_title {
    width: 100%;
    text-align: center;
    font-size: 24px;
    font-family: Source Han Sans CN, serif;
    font-weight: bold;
    color: #383838;
    margin-bottom: 30px;
  }

  .showbut {
    position: absolute;
    right: 36px;

    .el-button {
      padding: 10px 42px;
      font-size: 16px;
    }
  }
}

.table_title {
  display: flex;
  margin-bottom: 20px;

  .table_title_left {

  }

  .table_title_right {
    margin-left: auto;
  }
}

.Notice_list {
  ::v-deep .el-table th {
    background-color: #f5f8ff;
  }

  ::v-deep .el-table thead {
    color: #000000;
  }
}

.showbody_padding {
  padding: 30px 0;
}

.showbody_bor {
  border-top: 1px solid #eeeeee;
}

.showbody {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  font-family: Source Han Sans CN, serif;
  font-weight: 400;
  color: #969696;

  .inputbox_marginr {
    margin-right: 5%;
  }

  .inputbox {
    width: 30%;
    margin-bottom: 14px;

    .title {
      font-size: 14px;
      font-family: Source Han Sans CN, serif;
      font-weight: 400;
      color: #969696;
      margin-bottom: 14px;
    }

    .input {
      width: 100%;
      height: 36px;
      line-height: 36px;
      overflow: auto;
      white-space: nowrap;
      box-sizing: border-box;
      padding-left: 10px;
      background: #f4f7fd;
      border: 1px solid #dcdcdc;
    }

    .input::-webkit-scrollbar {
      display: none;
    }
  }
}

.searchlistbox {
  width: 100% !important;
  padding-top: 20px;
  margin-bottom: 20px;
  border: 1px solid #376bf4;
  display: flex;
  flex-wrap: wrap;

  .content_head_seek {
    margin-left: 20px;
    margin-bottom: 20px;
    // width: 25%;
  }
}

.content_head {
  width: 100%;
  display: flex;
  font-size: 18px;
  margin-bottom: 10px;

  .content_head_ico {
    height: 17px;
    width: 4px;
    padding-top: 4px;
    margin-right: 10px;
    // margin: auto 10px auto 0;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .content_head_title {
    white-space: nowrap;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #1b1b1b;
  }

  .content_head_button {
    flex: auto;
    max-width: 1050px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    margin-left: auto;

    .content_searchlistbox {
      position: relative;

      .content_searchlist {
        position: absolute;
        top: 40px;
        left: calc(50% - 9px);
      }
    }

    .content_head_seek {
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;
      margin-bottom: 20px;

      ::v-deep .el-input-group__append {
        padding: 0 18px;
      }
    }
  }
}

.paging {
  margin-top: 20px;

  ::v-deep .el-pagination {
    text-align: right;
  }
}
</style>
